export default "__VITE_PUBLIC_ASSET__0c07a02b__"